var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8107 5.86643C15.5837 5.63184 15.2755 5.5 14.9542 5.5C14.6328 5.5 14.3247 5.63184 14.0977 5.86643L8.52137 11.6168C8.04756 12.1054 8.04756 12.8946 8.52137 13.3832L14.0977 19.1336C14.5715 19.6221 15.3369 19.6221 15.8107 19.1336C16.2845 18.645 16.2845 17.8557 15.8107 17.3671L11.0969 12.4937L15.8107 7.63287C16.2845 7.14428 16.2723 6.34249 15.8107 5.86643Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLight);
export default __webpack_public_path__ + "static/media/arrow_left_light.2da10126.svg";
export { ForwardRef as ReactComponent };